import router from './router'
import auth from './store/modules/auth'
import axiosInstance from 'axios'
import i18n from './i18n'
import { BASE_URL } from './helpers/constants'
import { $eventBus, $localStorage } from './plugins/edunix';

const axios = axiosInstance.create({
	baseURL: BASE_URL,
})

axios.interceptors.request.use(function (config) {
	config.url =
		config.url
			.replace('{centerId}', $localStorage.centerId)
			.replace('{username}', $localStorage.username);
	return config;
}, function (error) {
	return Promise.reject(error);
});

axios.interceptors.response.use(
	function (response) {
		return response;
	},
	
	function (error) {
		if (!window.navigator.onLine) {
			$eventBus.$emit('show-snackbar', 'error', i18n.t('messages.your-are-offline'));
			return Promise.reject(error);
		}
		else if (error.response) {
			if (error.response.status === 401 && router.currentRoute.name !== 'login') {
				auth.state.authenticated = false;
				$localStorage.centerId = null;
				$localStorage.username = null;
				$localStorage.password = null;
				localStorage.removeItem('auth');
				auth.state.user = {};
				delete axios.defaults.headers.common['x-password'];

				router.replace({ name: 'login' });
			}
			$eventBus.$emit(
				'show-snackbar',
				'error',
				error.response.data.message ||
				error.response.data.error ||
				error.response.statusText ||
				i18n.t('messages.an-error-occurred')
			)
		}
		return Promise.reject(error);
	}
);
// window.axios = axios;
export default axios;